<template>
	<div class="modal-container-wrap">
		<div class="common-modal">
			<div class="modal-bg" v-if="showBg && isBgExist" @click="hideModal"></div>
			<div class="modal-content" ref="modalContent">
				<slot name="header">
					<div class="common-modal-header">
						<h3 class="title">{{ title }}</h3>
					</div>
				</slot>
				<div class="common-modal-body">
					<slot></slot>
				</div>
				<slot name="footer">
					<div class="common-modal-footer">
						<button @click="onCancel">取消</button>
						<button @click="onOk" class="primary">确定</button>
					</div>
				</slot>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'modal',
	data() {
		return {
			spaceHeight: 0,
		}
	},
	props: {
		title: {
			type: String,
			default: '',
		},
		width: {
			type: [String, Number],
			default: '500px',
		},
		height: {
			type: [String, Number],
			default: 'auto',
		},
		closeable: Boolean,
		showBg: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		isBgExist() {
			return !document.querySelector('.modal-bg')
		},
	},
	mounted() {
		this.resizePage()
		window.addEventListener('resize', this.resizePage)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resizePage)
	},
	methods: {
		hideModal() {
			this.closeable && this.$emit('hideModal')
		},
		onCancel() {
			this.$emit('onCancel')
		},
		onOk() {
			this.$emit('onOk', this)
		},
		resizePage(e) {
			const height = e ? e.target.innerHeight : window.innerHeight
			const modalHeight = this.$refs.modalContent.clientHeight

			this.spaceHeight = height < modalHeight ? 0 : (height - modalHeight) / 2
		},
	},
}
</script>
<style lang="scss" scoped>
.common-modal {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 999;
}
.modal-bg {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
}
.modal-content {
	position: fixed;
	z-index: 1001;
	margin: 0 auto;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
	background: #fff;
	border: 0;
	border-radius: 6px;
	background-clip: padding-box;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.common-modal-header {
	padding: 14px 16px;
	line-height: 1;
}
.common-modal-body {
	font-size: 12px;
	line-height: 1.5;
}
.common-modal-footer {
	padding: 12px 18px;
	text-align: right;
	button {
		display: inline-block;
		margin-bottom: 0;
		font-weight: 400;
		text-align: center;
		-ms-touch-action: manipulation;
		touch-action: manipulation;
		cursor: pointer;
		background-image: none;
		border: 1px solid transparent;
		white-space: nowrap;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		padding: 5px 15px 6px;
		font-size: 12px;
		border-radius: 4px;
		transition: color 0.2s linear, background-color 0.2s linear,
			border 0.2s linear, box-shadow 0.2s linear;
		color: #515a6e;
		background-color: #fff;
		border-color: #dcdee2;
	}
	.primary {
		color: #fff;
		background-color: #2d8cf0;
		border-color: #2d8cf0;
	}
}
</style>
